<template>
    <rkm-form
        ref="RkmForm"
        show-legend
    >
        <rkm-overlay :show="loading">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.nome"
                        label="Nome"
                        uppercase
                        v-model="model.nome"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-overlay>
    </rkm-form>
</template>

<script>
// Mixins.
import {error} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('cadastro-plano-funerario-form')
        },
        validations() {
            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
            }
        },
    },
    data: () => ({
        model: {
            nome: null,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            if (this.id) {
                this.setLoading('cadastro-plano-funerario-form')

                this.repositories.cadastro.planoFunerario.edit(this.id)
                    .then(({ data }) => this.model.nome = data.model.nome)
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('cadastro-plano-funerario-form'))
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        this.setLoading('cadastro-plano-funerario-form')

                        const request = {
                            nome: this.model.nome,
                        }

                        if (this.id) {
                            this.repositories.cadastro.planoFunerario.update(request, this.id)
                                .then(({ data }) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-plano-funerario-form'))
                        } else {
                            this.repositories.cadastro.planoFunerario.store(request)
                                .then(({ data }) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-plano-funerario-form'))
                        }
                    }
                })
        },
    },
    mixins: [error],
    mounted() {
        this.load()
    },
    props: {
        id: { type: Number },
    },
}
</script>